import React, { FC } from 'react';
import { DashboardFrame, ICellRendererWithDisabledParams } from '@aleph/supergrid';
import { getAdClickUrl } from 'wb-reddit/app/routes/superGrid/mutator/hooks/useCreateAds';
import { NoValuePlaceholder } from '@aleph/shared-components';

const CreativeContentDestinationUrlCellRenderer: FC<ICellRendererWithDisabledParams> = (params) => {
	const isDashboardView = params.data?.isDashboardView && !params.node.expanded;

	if (params?.data?.isCreate || params.disabled) {
		return (
			<NoValuePlaceholder
				placeholder={
					<div className="overflow-hidden overflow-ellipsis">
						{!params?.data?.isCreate ? (getAdClickUrl(params.data) ?? '—') : '—'}
					</div>
				}
			/>
		);
	}

	return (
		<>
			<div className="px-[8px] h-[64px] max-h-full flex items-center">
				{params.value}
			</div>
			{isDashboardView && <DashboardFrame />}
		</>
	);
};

export default CreativeContentDestinationUrlCellRenderer;
